import { FragmentLoginForm } from "../fragments.login/FragmentLoginForm";

export function PageLogin() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-blue-950 to-slate-900 px-4 py-12">

            {/* Decorative blobs */}
            <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
                <div className="absolute -top-40 -left-40 h-96 w-96 rounded-full bg-blue-600/20 blur-3xl" />
                <div className="absolute -bottom-40 -right-40 h-96 w-96 rounded-full bg-indigo-600/20 blur-3xl" />
            </div>

            {/* Card */}
            <div className="relative z-10 w-full max-w-md">
                <div className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur-xl shadow-2xl overflow-hidden">

                    {/* Card header */}
                    <div className="flex flex-col items-center px-8 pt-10 pb-6">
                        <img
                            src="/logo.png"
                            alt="DELDIA DISTRIBUCIONES"
                            className="h-16 w-auto object-contain mb-4 drop-shadow-lg"
                        />
                        <h1 className="text-2xl font-bold text-white tracking-tight">
                            ¡Bienvenido!
                        </h1>
                        <p className="text-sm text-blue-200/70 mt-1">
                            Ingresa tus credenciales para continuar
                        </p>
                    </div>

                    {/* Form */}
                    <div className="px-8 pb-8">
                        <FragmentLoginForm />

                        <div className="mt-5 text-center">
                            <a
                                href="forgot-password.html"
                                className="inline-flex items-center gap-1.5 text-sm text-blue-300/70 hover:text-blue-200 transition-colors"
                            >
                                <i className="fas fa-key text-xs"></i>
                                ¿Olvidaste tu contraseña?
                            </a>
                        </div>
                    </div>

                    {/* Footer */}
                    <div className="border-t border-white/10 px-8 py-4 text-center">
                        <p className="text-xs text-blue-200/40">
                            © {new Date().getFullYear()} DELDIA DISTRIBUCIONES. Todos los derechos reservados.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
